export default "__VITE_ASSET__C87sW4um__"